<template>
  <a-header>{{titleText}}</a-header>
  <div class="clm-form__main">
    <a-mob-header @action="$emit('close')" />
    <a-mob-text @action="$emit('go')" :line-type="lineType">{{titleText}}</a-mob-text>

    <slot></slot>

  </div>
  <div class="clm-form-bottom">
    <a-line-text @action="$emit('go')" :line-type="lineType" />
  </div>
</template>

<script>
import aHeader from "./a-header";
import aMobHeader from "./a-mob-header";
import aMobText from "./a-mob-text";
import aLineText from "./a-line-text";

export default {
  name: "a-layout",
  components: {
    aHeader,
    aMobHeader,
    aMobText,
    aLineText
  },
  props: {
    titleText: String,
    lineType: String,
  },
  emits: ['go', 'close']
}
</script>